export const separateArray = (arr, amount) => {
  let count = 0;

  const result = { visible: [], unvisible: [] };

  const resultPush = num => {
    result.visible.push(num);
    count += num.name.length;
  };

  arr?.forEach(num => {
    const fits = count < amount && count + num.name.length <= amount;
    const allowSingleTooLong = arr.length === 1;

    if (fits || allowSingleTooLong) resultPush(num);
    else result.unvisible.push(num);
  });

  return result;
};
